(function () {
  document.querySelectorAll('.oliiv').forEach(initOliiv);

  function initOliiv(root) {
    var sectionId = root.id.replace('oliiv-', '');
    var PACKS = {
      14: { sachets: 14, onetime: parseFloat(root.dataset.p14Onetime || '40'), sub: parseFloat(root.dataset.p14Sub || '30') },
      30: { sachets: 30, onetime: parseFloat(root.dataset.p30Onetime || '70'), sub: parseFloat(root.dataset.p30Sub || '55') }
    };
    var state = { billing: 'subscribe', pack: 30 };

    // Scroll nav
    root.querySelectorAll('[data-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var el = document.getElementById(btn.dataset.scroll);
        if (!el) return;
        var top = el.getBoundingClientRect().top + window.pageYOffset - 78;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // Reveal on scroll
    var revealEls = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    // Ritual video: play only while in view, always muted
    var video = root.querySelector('.oliiv-ritual-video');
    if (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { video.muted = true; video.play().catch(function () {}); }
          else { video.pause(); }
        });
      }, { threshold: 0.25 });
      vio.observe(video);
    }

    // Billing toggle
    var toggleBtns = root.querySelectorAll('[data-billing]');
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.billing = btn.dataset.billing;
        root.setAttribute('data-billing', state.billing);
        toggleBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        render();
      });
    });

    // Pack select
    var planCards = root.querySelectorAll('[data-pack]');
    planCards.forEach(function (card) {
      card.addEventListener('click', function () {
        state.pack = parseInt(card.dataset.pack, 10);
        planCards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        render();
      });
    });

    function fmt(n) { return '£' + (Math.round(n * 100) / 100); }
    function price(p) { return state.billing === 'subscribe' ? p.sub : p.onetime; }

    function render() {
      [14, 30].forEach(function (pack) {
        var p = PACKS[pack];
        var priceEl = root.querySelector('[data-price="' + pack + '"]');
        var compareEl = root.querySelector('[data-compare="' + pack + '"]');
        var perdayEl = root.querySelector('[data-perday="' + pack + '"]');
        var saveEl = root.querySelector('[data-save="' + pack + '"]');
        if (priceEl) priceEl.textContent = fmt(price(p));
        if (compareEl) compareEl.textContent = fmt(p.onetime);
        if (perdayEl) perdayEl.textContent = fmt(price(p) / p.sachets) + ' per sachet';
        if (saveEl) saveEl.textContent = 'Save ' + fmt(p.onetime - p.sub);
      });

      var selected = PACKS[state.pack];
      var ctaBtn = root.querySelector('[data-add-to-cart]');
      var ctaPriceEl = root.querySelector('[data-cta-price]');
      var assuranceEl = root.querySelector('[data-assurance]');
      var isSub = state.billing === 'subscribe';
      if (ctaPriceEl) ctaPriceEl.textContent = fmt(price(selected));
      if (ctaBtn) {
        ctaBtn.childNodes[0].textContent = isSub ? 'Subscribe — ' : 'Add to bag — ';
      }
      if (assuranceEl) {
        assuranceEl.textContent = isSub
          ? 'Free UK delivery · Pause or cancel anytime · No commitment'
          : 'Free UK delivery over £40 · 30-day happiness guarantee';
      }
    }

    // Add to cart (Shopify AJAX Cart API)
    var addBtn = root.querySelector('[data-add-to-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var isSub = state.billing === 'subscribe';
        var variantId, sellingPlanId;
        if (state.pack === 14) {
          variantId = isSub ? root.dataset.variant14Sub : root.dataset.variant14Onetime;
          sellingPlanId = root.dataset.sellingPlan14;
        } else {
          variantId = isSub ? root.dataset.variant30Sub : root.dataset.variant30Onetime;
          sellingPlanId = root.dataset.sellingPlan30;
        }
        if (!variantId) {
          console.warn('Oliiv: no variant ID configured for this pack/billing combo. Set it in Theme Editor → this section.');
          alert('This product option is not connected yet. Please contact the site owner.');
          return;
        }
        var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
        if (isSub && sellingPlanId) { body.items[0].selling_plan = parseInt(sellingPlanId, 10); }

        var originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (e) { throw e; });
            return res.json();
          })
          .then(function () {
            addBtn.textContent = 'Added to bag ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              addBtn.disabled = false;
              render();
            }, 1800);
          })
          .catch(function (err) {
            console.error('Oliiv add-to-cart error', err);
            addBtn.textContent = originalText;
            addBtn.disabled = false;
            alert((err && err.description) || 'Could not add to bag. Please try again.');
          });
      });
    }

    root.setAttribute('data-billing', state.billing);
    render();
  }
})();
